import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SegurosRestService } from './../../omni-rest/seguros/seguros-rest.service';

@Injectable({
  providedIn: 'root'
})
export class Omni1SalesService {
  constructor(
        private segurosRestService: SegurosRestService
    ) { }

  getPermissao(): Observable<{ hasPermission: boolean }> {
    return this.segurosRestService.get('omni1-sales/permissao/login');
  }
}
